import { useEffect, useState } from "react";
import { request } from "../../../../utils/request";
import { auth } from "../../../../utils/auth";
import dayjs from "dayjs";
import { toast } from "../../../../utils/helpers";
import { apiRequest } from "../../../../hooks/apiRequest";

const useVacacionesPendientes = () => {
    const [empleados, setEmpleados] = useState([]);
    const [cuentas, setCuentas] = useState([]);
    const [orden, setOrden] = useState('nombre');
    const [redondeo, setRedondeo] = useState(false);
    const [showTXTBR, setShowTXTBR] = useState(false);
    const [cuentaTXTBR, setCuentaTXTBR] = useState(null);

    const onChangeOrden = (e) => {
        setOrden(e.target.value);
    }

    const redondear = (cantidad) => {
        return Math.ceil(cantidad/5) * 5;
    }

    const user = auth.getUser();
    const sucursal = user.sucursales.filter(
        (suc) => suc.id === user.sucursalActual
    )[0];

    const totalEmpleados = empleados.length;

    const onChangeRedondear = () => {
        setRedondeo(!redondeo);
    }

    const denominaciones = [2000,1000,500,200,100,50,25,10,5,1];
    const vacacionesDesglose = (pago) => {
        const total = redondeo ? redondear(pago.prestaciones) : pago.prestaciones;

        return denominaciones.reduce((result, denominacion) => {
            const residuo = result['carry'] % denominacion;

            if (residuo === result['carry']) {
                result[denominacion] = 0;
            } else {
                result[denominacion] = (result['carry'] - residuo) / denominacion;
            }

            result['carry'] = residuo;

            return result;

        }, {'carry': total});
    }

    const totalPagar = empleados.reduce((acc, emp) => {
        return emp.montoPagar + acc;
    }, 0);

    const toggleTXTBR = () => {
        setShowTXTBR(prev => !prev);
    };

    const generarTXTBR = () => {
        const cuenta = cuentas?.find((c) => c.id === cuentaTXTBR.value);

        if (cuenta) {
            const rows = empleados.map(empleado => {
                return [
                    cuenta.tipo_cuenta === "Ahorros" ? "CA" : "CC",
                    cuenta.moneda,
                    cuenta.numeroCuenta,
                    "CC",
                    "DOP",
                    empleado.cuenta_bancaria,
                    empleado.montoPagar,
                    (`${empleado.nombre} ${empleado.apellido}`).replaceAll('¥', 'N').replaceAll('Ñ', 'N'),
                ];
            });

            const csvContent = `data:text/plain;charset=utf-8,${rows.map(e => e.join(",")).join("\n")}`;

            const encodedUri = encodeURI(csvContent);
            const link = document.createElement("a");

            link.setAttribute("href", encodedUri);
            link.setAttribute("download", "vacaciones-br.txt");
            document.body.appendChild(link); //Firefox Fix
            link.click();

            toggleTXTBR();
        } else {
            toast("Selecciones una cuenta valida", 'error')
        }
    };

    const getCuentas = async (url = null) => {
        url = url ? url : "cuentas";
        const cuentas = await apiRequest(null, url, 'GET');

        if (cuentas.data?.length > 0) {
            setCuentas(cuentas.data);
        }
    };

    const totalRedondeado = redondear(totalPagar);

    const resumenDesglose = 0;

    const params = new URLSearchParams(window.location.search);

    useEffect(() => {
        const getEmpleados = async () => {
            const params = new URLSearchParams(window.location.search);
            params.set('con-pagos', 1);
            const response = await request(
                "empleados/vacaciones-pendientes?" + params.toString()
            );

            if (response.data) {
                setEmpleados(response.data.map(emp => {
                    const sueldoDia = parseFloat(emp.sueldo) / 23.83;
                    const anios = dayjs().diff(dayjs(emp.fecha_ingreso), 'year');
                    const montoPagar = anios < 5 ? sueldoDia * 14 : sueldoDia * 18;
                    emp.anios = anios;
                    emp.montoPagar = montoPagar;
                    return emp;
                }));
            }
        };
        getEmpleados();
        getCuentas();
    }, []);

    return {
        empleados,
        orden,
        onChangeOrden,
        onChangeRedondear,
        sucursal,
        redondear,
        totalPagar,
        totalRedondeado,
        resumenDesglose,
        denominaciones,
        vacacionesDesglose,
        totalEmpleados,
        redondeo,
        params,
        cuentas,
        generarTXTBR,
        cuentaTXTBR,
        showTXTBR,
        toggleTXTBR,
        setCuentaTXTBR
    }
}

export default useVacacionesPendientes;
